import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Was genau macht ManageMatch?",
    answer: "ManageMatch koordiniert und organisiert professionelle Dienstleistungen für Privat- und Gewerbekunden in Hanau und der Rhein-Main-Region. Wir sind Ihr zentraler Ansprechpartner und stellen qualifizierte Fachkräfte für Hausmeisterservice, Reinigung, Elektro, Gartenpflege, Winterdienst, Security, Car Detailing und IT Helpdesk bereit.",
  },
  {
    question: "Wer führt die beauftragten Arbeiten durch?",
    answer: "Die Arbeiten werden von sorgfältig ausgewählten und geprüften Fachkräften und Partnerunternehmen durchgeführt. ManageMatch fungiert als Ihr einziger Ansprechpartner – wir koordinieren alles für Sie.",
  },
  {
    question: "Welche Dienstleistungen organisiert ManageMatch?",
    answer: "Wir decken acht Kernbereiche ab: Hausmeisterservice, Elektrotechnik, Car Detailing, IT Helpdesk, Gartenarbeiten, Security Service, Winterdienst und Reinigungsservice – jeweils maßgeschneidert für Privat- und Gewerbekunden.",
  },
  {
    question: "Wie wird die Qualität der Dienstleister sichergestellt?",
    answer: "Alle unsere Partner werden sorgfältig ausgewählt und regelmäßig überprüft. Wir holen nach jedem Auftrag Feedback ein, um die Qualität kontinuierlich zu verbessern und erstklassige Ergebnisse zu garantieren.",
  },
  {
    question: "In welchen Regionen ist ManageMatch tätig?",
    answer: "ManageMatch ist hauptsächlich in Hanau und der gesamten Rhein-Main-Region aktiv. Für genaue Informationen zu unserem Einzugsgebiet kontaktieren Sie uns bitte direkt.",
  },
  {
    question: "Wie schnell kann ManageMatch einen Dienstleister organisieren?",
    answer: "Je nach Dienstleistung und Verfügbarkeit können wir oft innerhalb von 24–48 Stunden einen qualifizierten Fachmann organisieren. Bei dringenden Notfällen reagieren wir noch schneller.",
  },
  {
    question: "Sind die beauftragten Dienstleister versichert?",
    answer: "Ja, alle unsere Partnerunternehmen und Fachkräfte verfügen über die notwendigen Versicherungen und Zertifizierungen für ihre jeweiligen Tätigkeitsbereiche.",
  },
  {
    question: "Bietet ManageMatch auch regelmäßige Dienstleistungen an?",
    answer: "Ja, wir organisieren sowohl einmalige als auch regelmäßige Dienstleistungen. Für wiederkehrende Aufträge können wir individuelle Vereinbarungen mit zuverlässigen Partnern für Sie treffen.",
  },
  {
    question: "Was kostet der Service von ManageMatch?",
    answer: "Wir erstellen transparente Angebote ohne versteckte Kosten. Die Anfrage und Beratung ist kostenfrei und unverbindlich – kontaktieren Sie uns einfach für ein individuelles Angebot.",
  },
  {
    question: "Was passiert bei Unzufriedenheit mit dem Dienstleister?",
    answer: "Ihre Zufriedenheit hat höchste Priorität. Bei Problemen melden Sie sich umgehend bei uns – wir finden gemeinsam eine Lösung und organisieren bei Bedarf einen alternativen Fachmann.",
  },
];

const FAQSection = () => {
  const leftFaqs = faqs.slice(0, 5);
  const rightFaqs = faqs.slice(5);

  return (
    <section className="py-12 md:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto glass-card rounded-2xl md:rounded-3xl p-5 md:p-10 mb-4 md:mb-5 bg-lavender/60">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Antworten auf die wichtigsten Fragen zu den Dienstleistungen von ManageMatch (Manage Match)
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-6xl mx-auto">
          <Accordion type="single" collapsible className="space-y-2 md:space-y-4">
            {leftFaqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`left-${index}`}
                className="glass-card rounded-xl md:rounded-2xl px-4 md:px-6 border-none hover:shadow-card transition-shadow"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground hover:text-primary py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <Accordion type="single" collapsible className="space-y-2 md:space-y-4">
            {rightFaqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`right-${index}`}
                className="glass-card rounded-xl md:rounded-2xl px-4 md:px-6 border-none hover:shadow-card transition-shadow"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground hover:text-primary py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
